module.exports = {"locationCap":["Front Center","Front Left","Front Right","Left","Right","Back Center"],"locationShirt":["Left Chest","Right Chest","Left Bottom","Right Bottom","Upper Left Sleeves","Upper right Sleeves","Left Wrist","Right Wrist"]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/fakeLocation.json
// module id = WmiT
// module chunks = 1